var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _c("h1", { attrs: { slot: "header" }, slot: "header" }, [
      _vm._v("Delete Document Category"),
    ]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "form",
        staticClass: "form",
        attrs: { novalidate: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("ValidationAlert", {
          attrs: { "error-list": _vm.errors.collect("server") },
        }),
        _vm._v(" "),
        _vm.serverErrors
          ? _c("ValidationAlert", { attrs: { "error-list": _vm.serverErrors } })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "fieldset",
          { staticClass: "form__group" },
          [
            _c("FormControlInsightCategory", {
              ref: "cats",
              attrs: { label: "Select a category", name: "category" },
              model: {
                value: _vm.formData.category,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "category", $$v)
                },
                expression: "formData.category",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.formData.delete_children,
                    expression: "formData.delete_children",
                  },
                ],
                attrs: { id: "delete_children", type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.formData.delete_children)
                    ? _vm._i(_vm.formData.delete_children, null) > -1
                    : _vm.formData.delete_children,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.formData.delete_children,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.formData,
                            "delete_children",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.formData,
                            "delete_children",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.formData, "delete_children", $$c)
                    }
                  },
                },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "delete_children" } }, [
                _vm._v("Delete child categories?"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form__group form__group--submit" }, [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "wait",
                      rawName: "v-wait:disabled",
                      value: "submit",
                      expression: '"submit"',
                      arg: "disabled",
                    },
                  ],
                  staticClass: "btn btn--primary",
                },
                [
                  _vm.$wait.is("submit")
                    ? _c("Spinner", { attrs: { height: 13, width: 13 } })
                    : _c("span", [_vm._v("Delete")]),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }